import { defineField } from 'sanity';

export const AboutUsSectionSchema = defineField({
	name:   'aboutUs',
	title:  'About Us Section',
	type:   'object',
	fields: [
		defineField({
			name:       'title',
			title:      'Title',
			type:       'localizedText',
			validation: Rule => Rule.required(),
		}),
		defineField({
			name:       'description',
			title:      'Description',
			type:       'localizedBlockContent',
			validation: Rule => Rule.required(),
		}),
		defineField({
			name:       'youtubeUrl',
			title:      'YouTube Video URL',
			type:       'url',
			validation: Rule => Rule.uri({ scheme: [ 'http', 'https' ] }),
		}),
	],
});